import { ErrorMessageProps } from '@copilotkit/react-ui';
import * as React from 'react';
import localeService from 'src/dataServices/LocaleService';

export const ChatErrorMessage: React.FC<ErrorMessageProps> = ({ onRegenerate }) => {
  return (
    <div className="copilotKitMessage copilotKitAssistantMessage" role="alert">
      {localeService.getText('ContactUs', 'ChatErrorMessage')}
    </div>
  );
};
